<template>
  <item-detail-base item-title="社会责任">
    <div class="social-title">
        <span>社会责任</span>
    </div>
    <content-base-item :content-des="Des" :content-img="Img" v-if="Des && Img"></content-base-item>
  </item-detail-base>
</template>

<script>
  import ItemDetailBase from "../Common/ItemDetailBase";
  import ContentBaseItem from "../Common/ContentBaseItem";
  export default {
    name: "HomeSociety",
    components: {ContentBaseItem, ItemDetailBase},
    data(){
      return{
        Des:null,
        Img:null,
      }
    },
    created() {
      this.GetData()
    },
    methods:{
      GetData(data){
        this.$axios.get('/api/companyIntro/getCompanyIntro').then(res=>{
          // console.log(res);
          this.Img=res.data.data.worldDutyPhotoUrl;
          this.Des=res.data.data.worldDutyDescription;
          console.log(this.Des)


        })
      },
    }
  }
</script>

<style lang="less" scoped>
.social-title{
  margin: 0 auto;
  text-align: center;
  padding: 30px 0 60px 0;
  span{
    width: 132px;
    height: 32px;
    font-size: 32px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 48px;
    letter-spacing: 1px;
  }
}
</style>